<template>
  <sd-modal top="15%" left="33%" v-show="show">
    <div class="form_modal">
        <i class="close"></i>
        <p class="form_title">发票信息</p>
        <div class="form_ctr">
            <p class="error"></p>
            <label :class="{'req':true}">发票类型</label>
            <select class="short select" style="-webkit-appearance: menulist;" v-model="param.invoiceType" @change="dirtyAll(false)">
              <option value="1">增值税普通发票</option>
              <option value="2">增值税专用发票</option>
            </select>
        </div>
        <div class="form_ctr" :class="{'invalid':!checkInvoiceTitle}">
            <p class="error">请填写发票抬头</p>
            <label :class="{'req':true}">发票抬头</label>
            <input type="text" class="long" v-model="param.invoiceTitle" @blur="dirty.invoiceTitle = true" maxlength="42">
        </div>
        <div class="form_ctr" :class="{'invalid':!checkIdentifyNumber}">
            <p class="error">请填写纳税人识别号</p>
            <label :class="{'req':true}">纳税人识别号</label>
            <input type="text" class="long" v-model="param.identifyNumber"   @blur="dirty.identifyNumber = true" maxlength="40">
        </div>
        <div class="form_ctr" :class="{'invalid':!checkRegAddress}">
            <p class="error">请填写注册地址</p>
            <label :class="{'req':isZP}">注册地址</label>
            <input type="text" class="long" v-model="param.regAddress"  @blur="dirty.regAddress = true" maxlength="80">
        </div>
        <div class="form_ctr" :class="{'invalid':!checkRegPhone}">
            <p class="error">请填写注册电话</p>
            <label :class="{'req':isZP}">注册电话</label>
            <input type="text" class="short" v-model="param.regPhone"   @blur="dirty.regPhone = true" maxlength="17">
        </div>
        <div class="form_ctr" :class="{'invalid':!checkRegBank}">
            <p class="error">请填写开户银行名称</p>
            <label :class="{'req':isZP}">开户银行</label>
            <input type="text" class="long" v-model="param.regBank"   @blur="dirty.regBank = true" maxlength="42">
        </div>
        <div class="form_ctr" :class="{'invalid':!checkBankNumber}">
            <p class="error">请填写银行账号</p>
            <label :class="{'req':isZP}">银行账号</label>
            <input type="text" class="long" v-model="param.bankNumber"   @blur="dirty.bankNumber = true" maxlength="34">
        </div>
        <div class="form_ctr" style="margin-top: -10px;">
            <p class="error"></p>
            <input type="checkbox" style="margin-left: 166px;" v-model="param.haveDefault">设为默认
        </div>
        <ul class="btn">
            <li v-if="type=='add'" @click="addInvoice">新增</li>
            <li v-if="type=='update'" @click="updateInvoice">保存</li>
            <li @click="show = false">返回</li>
        </ul>
    </div>
  </sd-modal>
</template>

<script type="es6">
    import { mapState, mapActions, mapGetters } from 'vuex'
    import { util } from '../service/util'
    import sdModal from '../components/sdModal'

    let API = util.api([
        'UPDATEUSERINVOICE',
        'ADDINVOICEINFO'
      ])
    export default {
        name:'add-invoce',
        props: ['address'],
        components: { sdModal },
        data () {
            return {
                show: false,
                type: '',
                param: {
                  "invoiceType": "1",//"发票类型(1增值税普通发票2增值税专用发票)(Integer)",
                  "invoiceTitle": "",//"发票抬头(String,最大长度:42)",
                  "regAddress": "",//"注册地址(String,最大长度:84)",
                  "regPhone": "",//"注册电话(String,最大长度:17)",
                  "regBank": "",//"开户银行(String,最大长度:42)",
                  "bankNumber": "",//"银行账户(String,最大长度:34)",
                  "identifyNumber": "",//"纳税人识别号(String,最大长度:84)",
                  "haveDefault": "",//"是否是默认(1不是默认2是默认)(Integer)",
                },
                dirty: {
                  "invoiceType": "",
                  "invoiceTitle": "",
                  "regAddress": "",
                  "regPhone": "",
                  "regBank": "",
                  "bankNumber": "",
                  "identifyNumber": "",
                  "haveDefault": "",
                },
                // 父级的原始数据
                pParam: {}
            }
        },
        computed: {
           _haveDefault() {
            return this.param.haveDefault == 2;
           },
           // 是专票
           isZP() {
            return this.param.invoiceType == 2;
           },
           checkInvoiceTitle() {
            if(!this.dirty.invoiceTitle){
              return true;
            }
            return this.param.invoiceTitle
           },
           checkIdentifyNumber() {
            if(!this.dirty.identifyNumber){
              return true;
            }
            return this.param.identifyNumber;
           },
           checkRegAddress() {
            if(this.isZP){
              if(!this.dirty.regAddress){
                return true;
              }
              return this.param.regAddress;
            }
            return true;
           },
           checkRegPhone() {
            if(this.isZP){
              if(!this.dirty.regPhone){
                return true;
              }
              return this.param.regPhone;
            }
            return true;
           },
           checkRegBank() {
            if(this.isZP){
              if(!this.dirty.regBank){
                return true;
              }
              return this.param.regBank;
            }
            return true;
           },
           checkBankNumber() {
            if(this.isZP){
              if(!this.dirty.bankNumber){
                return true;
              }
              return this.param.bankNumber;
            }
            return true;
           },
           checkAll() {
            this.dirtyAll(true);
            return this.checkInvoiceTitle && this.checkRegAddress && this.checkRegPhone && this.checkRegBank && this.checkBankNumber && this.checkIdentifyNumber;
           }
        },
        methods: {
          init() {
            Object.assign(this.$data, this.$options.data());
          },
          dirtyAll(bool) {
            for(let key in this.dirty){
              this.dirty[key] = bool;
            }
          },
          doUpdate(data) {
            this.show = true;
            // 操作的类型
            this.type = 'update';
            // 拷贝数据
            let obj = util.copy(data);
            obj.haveDefault = obj.haveDefault == 2 ? true : false;
            this.param = obj;
          },
          doAdd() {
            this.init();
            this.show = true;
            this.type = 'add';
          },
          // 更新父级原始数据
          updateOriginal() {
            for(var key in this.param){
              this.pParam[key] = this.param[key];
            }
          },
          // 新增
          addInvoice() {
            if(!this.checkAll){
              return;
            }

            let param = util.copy(this.param);
            if(param.haveDefault === true){
              param.haveDefault = 2;
            } else {
              param.haveDefault = 1;
            }
            util.kAjax(API.ADDINVOICEINFO, param, res => {
              this.init();
              this.$emit('on-success');
              this.show = false;
              // util.confirm.success('新增发票成功！');
            })
          },
          // 更新
          updateInvoice() {
            if(!this.checkAll){
              return;
            }
            let param = util.copy(this.param);
            if(param.haveDefault === true){
              param.haveDefault = 2;
            } else {
              param.haveDefault = 1;
            }
            util.kAjax(API.UPDATEUSERINVOICE, param, res => {
              // 更新成功，更新原生数据，清空当前数据
              // this.updateOriginal();
              this.show = false;
              this.$emit('on-success');
              this.init();
              util.confirm.success('更新发票成功！');
            })
          },
        },
        watch: {

        },
        created() {

        }
    }
</script>

<style lang="scss" scoped="">
  .error{
    visibility: hidden;
  }
</style>



// WEBPACK FOOTER //
// addInvoice.vue?6301c06e